import { useEffect, useRef } from "react";
import { isMobile, isTablet } from "react-device-detect";

import {
  TOUR_OFFSET_DESKTOP,
  TOUR_OFFSET_MOBILE,
  PROGRESS_OFFSET_DESKTOP,
  PROGRESS_OFFSET_MOBILE,
} from "@/constants";
import * as vars from "@/styles/_variables.scss";
import {} from "../constants";

export const lockBodyScrolling = () => {
  const html = document.querySelector("html");
  html.style.overflow = "hidden";
  console.log("locking body scroll");
};

export const restoreBodyScrolling = () => {
  const html = document.querySelector("html");
  html.style.overflow = "visible";
  console.log("restoring body scroll");
};

export const debounce = (func, wait, immediate) => {
  let timeout;

  return function() {
    const context = this,
      args = arguments; // eslint-disable-line
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;

    timeout && clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const throttle = (func, limit) => {
  let inThrottle;

  return function() {
    const context = this, // eslint-disable-line
      args = arguments; // eslint-disable-line

    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

export const EaseOutExpo = (t, b, c, d) =>
  c * (-Math.pow(3, (-10 * t) / d) + 1) + b;

export const isDesktop = (hasMounted, screenClass) => {
  // lg+ tablet or md+ desktop
  return hasMounted
    ? (!isMobile || ["lg", "xl", "xxl"].includes(screenClass)) &&
        ["md", "lg", "xl", "xxl"].includes(screenClass)
    : false;
};

export const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export const getTourOffset = (isDesktop) =>
  isDesktop ? TOUR_OFFSET_DESKTOP : TOUR_OFFSET_MOBILE;

export const getProgressOffset = (isDesktop) =>
  isDesktop ? PROGRESS_OFFSET_DESKTOP : PROGRESS_OFFSET_MOBILE;

export const getStopIndex = (currentFrame, scrollOffset, tourHeight) => {
  console.log("frame:" + currentFrame);
  let stopIndex = -1;
  // console.log(currentFrame);
  if (scrollOffset < 200) {
    // Title
    stopIndex = 0;
  } else if (scrollOffset < 500) {
    // Introduction
    stopIndex = 0.5;
  } else if (currentFrame < 1) {
    // Title disappears
    stopIndex = 1;
  } else if (currentFrame < 4) {
    // Progress indicator appears
    stopIndex = 2;
  } else if (currentFrame < 8.5) {
    // Indicator goes away
    stopIndex = 2.4;
  } else if (currentFrame < 11) {
    // Video is zooming
    stopIndex = 2.5;
  } else if (currentFrame < 13) {
    // Stop points
    stopIndex = 6;
  } else if (currentFrame < 19) {
    stopIndex = 6.5;
  } else if (currentFrame < 21) {
    stopIndex = 7;
  } else if (currentFrame < 28) {
    stopIndex = 7.5;
  } else if (currentFrame < 31) {
    stopIndex = 8;
  } else if (currentFrame < 37) {
    stopIndex = 8.5;
  } else if (currentFrame < 40) {
    stopIndex = 9;
  } else if (currentFrame < 41) {
    stopIndex = 9.5;
  } else if (scrollOffset < tourHeight) {
    // Outro
    stopIndex = 10;
  } else {
    // Sections
    stopIndex = 11;
  }

  return stopIndex;
};

export const CONTAINER_WIDTHS = {
  sm: vars.containerSm,
  md: vars.containerMd,
  lg: vars.containerLg,
  xl: vars.containerXl,
  xxl: vars.containerXxl,
};

export const getContainerWidth = (screenClass, windowWidth) => {
  if (screenClass === "xs")
    return windowWidth ? Math.max(windowWidth, 375) : 375;

  return parseInt(CONTAINER_WIDTHS[screenClass]);
};

export const getTourOutroHeight = (windowHeight, isDesktop) =>
  windowHeight * (isDesktop && !isTablet ? 4 : 5);

export const shallowCompare = (newObj, prevObj) => {
  for (let key in newObj) {
    if (newObj[key] !== prevObj[key]) return true;
  }

  return false;
};
